/** Langues alignées sur `supportedLngs` dans i18n.ts (UI sélecteur). */
export const UI_LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
  { code: 'lb', label: 'Lëtzebuergesch', flag: '🇱🇺' },
  { code: 'uk', label: 'Українська', flag: '🇺🇦' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦' },
  { code: 'tr', label: 'Türkçe', flag: '🇹🇷' },
  { code: 'zgh', label: 'Amazighe', flag: '🇲🇦' },
] as const;

/** Nombre de langues exposées dans les sélecteurs player / UI produit. */
export const UI_LANGUAGE_COUNT = UI_LANGUAGES.length;

export type UiLanguageCode = (typeof UI_LANGUAGES)[number]['code'];

/** Même ordre / contenu que le sélecteur du player EduFlow — sous-titres, transcription, etc. */
export const UI_LANGUAGE_CODES: readonly UiLanguageCode[] = UI_LANGUAGES.map((l) => l.code);

export function currentUiLangCode(i18nLang: string | undefined): string {
  return (i18nLang ?? 'fr').split('-')[0];
}

/** Code court aligné sur `UI_LANGUAGES`, ou null si non supporté. */
export function parseSupportedUiLangCode(raw: string | null | undefined): UiLanguageCode | null {
  if (raw == null || raw === '') return null;
  const code = raw.split('-')[0].toLowerCase();
  return UI_LANGUAGES.some((l) => l.code === code) ? (code as UiLanguageCode) : null;
}
